export default "__VITE_ASSET__BGyMMbJg__"